/**
 * JournalPanel — timeline temps réel des événements du journal DPI.
 * Extrait de DpiLivePage (US-VDPI-06) pour réutilisation /vocal (Phase 1 A3, DRY).
 */

import type { JournalEntry } from '@/shared/types/dpi';
import { useNewItems } from './useNewItems';
import { formatTime, summarizeData } from './summarize';
import './dpi.css';

export function JournalPanel({ journal }: { journal: JournalEntry[] }) {
  // Clé stable par event (pas d'id dédié côté DTO) → ts + index.
  const keys = journal.map((j, i) => `${j.ts}#${i}`);
  const newKeys = useNewItems(keys);

  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-header bg-transparent border-bottom py-3 d-flex align-items-center gap-2">
        <i className="bi bi-journal-text text-primary" />
        <span className="fw-semibold">Journal temps réel</span>
        <span className="dpi-live-dot ms-auto" />
      </div>
      <div className="card-body p-3" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {journal.length === 0 ? (
          <p className="text-muted text-center py-3 mb-0">
            <i className="bi bi-hourglass-split me-1" />
            En attente d'événements...
          </p>
        ) : (
          [...journal].reverse().map((entry, revIdx) => {
            const idx = journal.length - 1 - revIdx;
            const key = keys[idx];
            return (
              <div
                key={key}
                className={`dpi-journal-item mb-3 ${newKeys.has(key) ? 'dpi-new-entry' : ''}`}
                data-testid="dpi-journal-item"
              >
                <div className="d-flex align-items-center justify-content-between">
                  <span className="fw-semibold small">{entry.event}</span>
                  <span className="text-muted" style={{ fontSize: '0.7rem' }}>
                    {formatTime(entry.ts)}
                  </span>
                </div>
                <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                  {entry.intent && <span className="me-2">{entry.intent}</span>}
                  {entry.patient_id && <span className="me-2">· {entry.patient_id}</span>}
                  {Object.keys(entry.slots).length > 0 && (
                    <span>· {summarizeData(entry.slots)}</span>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
